export default "__VITE_ASSET__f2322fb8__"